import { Link } from "react-router-dom"
import styled from "styled-components"
import { Text } from "../elements/Text"

const Container = styled(Text).attrs({ size: "sm", center: true })`
  font-weight: 700;
  width: 100%;
  display: block;
`

const StyledLink = styled(Link)`
  color: ${(props) => props.theme.colors.primary};
  font-size: 0.75rem;
  font-size: clamp(0.75rem, 0.7rem + 0.25vw, 1rem);
`

const Consent = () => {
  return (
    <Container size="sm" center>
      <StyledLink
        to="https://jp.josys.com/privacy"
        rel="noopener noreferrer"
        target="_blank"
      >
        ジョーシスプライバシーポリシー
      </StyledLink>
    </Container>
  )
}

export { Consent }
